export const ADMIN_BUTTON_LABEL = "Admin";
export const SIGN_OUT_BUTTON_LABEL = "Sign Out";

export const GRIT_LEADERSHIP_SLOGAN =
  "Becoming a better athletic director starts here.";
export const MARKETING_PAGE_LINK_LABEL = "About Grit Leadership";



// WEBPACK FOOTER //
// ./src/features/home/pages/sub-pages/home-page/constants.ts